import React from 'react'
import './ItemBlock.scss'
import classNames from 'classnames';
import {BsCheckLg, Close} from 'react-icons/bs'
import {RiCloseFill} from 'react-icons/ri'

function ItemBlock({item, index, row, onSelected, onHover, onClick, selected, isCorrect, isAnswer, items, help}) {

  const top = index * 80 + 20;
  const left = row == 1 ? 20 : 400;

  const style = {
    top,
    left
  };

  let find;
  if(row == 1){
    find = items.find(_i => item._id == _i._id);
  } else {
    find = items.find(_i => item._id == _i.answerId);
  }

  return (
    <div className={'ItemBlock7' + (selected == index ? ' active' : '')} style={style}>
      <div className='text' style={{marginLeft: row !== 1 ? 15 : 0}}>
        {row == 1 ? item.question : item.answer}
      </div>
      {row == 1 && <div className={classNames('point', {active: find && Boolean(find.answerId),})} onClick={onSelected}>

      </div>}
      {row == 2 && <div className={classNames('point_answer', {
        active: find && Boolean(find.answerId),
        isTrue: isCorrect && isAnswer && help,
        isFalse: !isCorrect && isAnswer && help,
      })} onMouseMove={onHover} onClick={() => onClick(item._id)}>
        {isCorrect && isAnswer && help && <BsCheckLg size={12} color='white' />}
        {!isCorrect && isAnswer && help && <RiCloseFill color='white' />}
      </div>}
    </div>
  )
}

export default ItemBlock


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/components/AnswersType7/components/ItemBlock.jsx